export const timezones = [
  { label: '(UTC-10) Honolulu', offset: -10, value: 'Pacific/Honolulu' },
  { label: '(UTC-8) Juneau', offset: -8, value: 'America/Juneau' },
  { label: '(UTC-7) Los Angeles', offset: -7, value: 'America/Los_Angeles' },
  { label: '(UTC-6) Denver', offset: -6, value: 'America/Denver' },
  { label: '(UTC-5) Chicago', offset: -5, value: 'America/Chicago' },
  { label: '(UTC-4) New York', offset: -4, value: 'America/New_York' },
  { label: '(UTC-3) Sao Paulo', offset: -3, value: 'America/Sao_Paulo' },
  { label: '(UTC) London', offset: 0, value: 'Europe/London' },
  { label: '(UTC+1) Amsterdam', offset: 1, value: 'Europe/Amsterdam' },
  { label: '(UTC+2) Bucharest', offset: 2, value: 'Europe/Bucharest' },
  { label: '(UTC+3) Moscow', offset: 3, value: 'Europe/Moscow' },
  { label: '(UTC+3:30) Tehran', offset: 3.5, value: 'Asia/Tehran' },
  { label: '(UTC+4) Dubai', offset: 4, value: 'Asia/Dubai' },
  { label: '(UTC+5) Karachi', offset: 5, value: 'Asia/Karachi' },
  { label: '(UTC+5:30) Kolkata', offset: 5.5, value: 'Asia/Kolkata' },
  { label: '(UTC+5:45) Kathmandu', offset: 5.75, value: 'Asia/Kathmandu' },
  { label: '(UTC+6) Dhaka', offset: 6, value: 'Asia/Dhaka' },
  { label: '(UTC+6:30) Yangon', offset: 6.5, value: 'Asia/Yangon' },
  { label: '(UTC+7) Bangkok', offset: 7, value: 'Asia/Bangkok' },
  { label: '(UTC+8) Perth', offset: 8, value: 'Australia/Perth' },
  { label: '(UTC+8) Shanghai', offset: 8, value: 'Asia/Shanghai' },
  { label: '(UTC+9) Tokyo', offset: 9, value: 'Asia/Tokyo' },
  { label: '(UTC+10) Brisbane', offset: 10, value: 'Australia/Brisbane' },
  { label: '(UTC+10:30) Adelaide', offset: 10.5, value: 'Australia/Adelaide' },
  { label: '(UTC+11) Sydney', offset: 11, value: 'Australia/Sydney' },
  { label: '(UTC+12) Norfolk Island', offset: 12, value: 'Pacific/Norfolk' },
  { label: '(UTC+13) New Zealand', offset: 13, value: 'Pacific/Auckland' },
  { label: '(UTC+13:45) Chatham Islands', offset: 13.75, value: 'Pacific/Chatham' },
];
